import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { ToasterToast, useToast } from "@/components/ui/use-toast";
import { SuccessIcon } from "../icons/SuccessIcon";
import { InfoIcon } from "../icons/InfoIcon";
import { isObject } from "lodash-es";

export const TOAST_DURATION = 3000;
export const MAX_TOAST_DURATION = 600000;

export function Toaster() {
    const { toasts } = useToast();
    return (
        <ToastProvider swipeDirection="up">
            {toasts.map((t) => (
                <ToastWrapper key={t.id} {...t} />
            ))}
            <ToastViewport />
        </ToastProvider>
    );
}

function ToastIcon({ variant }: { variant?: string | null }) {
    if (variant === "success") {
        return <SuccessIcon className="h-6 w-6" />;
    }
    if (variant === "destructive") {
        return <InfoIcon className="h-6 w-6 text-red-700" />;
    }
    return <InfoIcon className="h-6 w-6 text-yellow-700" />;
}

function ToastWrapper(props: ToasterToast) {
    const { id, duration, title, description, action, variant, isPermanent, customIcon, hideCloseButton, ...extra } =
        props;

    const errorDescription = isObject(description) ? (
        description
    ) : (
        <span dangerouslySetInnerHTML={{ __html: description as string }}></span>
    );

    const effectiveDuration = duration ?? (isPermanent ? MAX_TOAST_DURATION : TOAST_DURATION);

    return (
        <Toast variant={variant} {...extra} duration={effectiveDuration}>
            <div className="flex items-center gap-4 bg-transparent">
                <div className="h-6 w-6 flex-shrink-0">{customIcon ?? <ToastIcon variant={variant} />}</div>
                <div className="grid gap-1">
                    {title && <ToastTitle>{title}</ToastTitle>}
                    {description && <ToastDescription>{errorDescription}</ToastDescription>}
                </div>
            </div>
            {action}
            {(isPermanent || variant === "destructive") && !hideCloseButton && <ToastClose />}
        </Toast>
    );
}
